// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { brewSensoryAnalystId } from './BrewSensoryAnalyst';
import { brewSensorySessionSampleId } from './BrewSensorySessionSample';
import { brewSensorySessionQuestionId } from './BrewSensorySessionQuestion';
import { z } from 'zod';
export const brewSensoryResponseId = (z.number());
export const brewSensoryResponse = z.object({
    id: brewSensoryResponseId,
    analyst_id: brewSensoryAnalystId,
    sample_id: brewSensorySessionSampleId.nullable(),
    question_id: brewSensorySessionQuestionId,
    value_text: z.string().nullable(),
    value_number: z.number().nullable(),
    value_json: z.unknown().nullable(),
    answered_at: z.date(),
});
export const brewSensoryResponseInitializer = z.object({
    id: brewSensoryResponseId.optional(),
    analyst_id: brewSensoryAnalystId,
    sample_id: brewSensorySessionSampleId.optional().nullable(),
    question_id: brewSensorySessionQuestionId,
    value_text: z.string().optional().nullable(),
    value_number: z.number().optional().nullable(),
    value_json: z.unknown().optional().nullable(),
    answered_at: z.date().optional(),
});
export const brewSensoryResponseMutator = z.object({
    id: brewSensoryResponseId.optional(),
    analyst_id: brewSensoryAnalystId.optional(),
    sample_id: brewSensorySessionSampleId.optional().nullable(),
    question_id: brewSensorySessionQuestionId.optional(),
    value_text: z.string().optional().nullable(),
    value_number: z.number().optional().nullable(),
    value_json: z.unknown().optional().nullable(),
    answered_at: z.date().optional(),
});
//# sourceMappingURL=BrewSensoryResponse.js.map